import { Commission } from '@shared/interfaces/commission';
import { Observable } from 'rxjs';

export const COMMISSION_REPOSITORY = 'CommissionsRepository';

export interface CommissionsRepository {
  url: string;

  getItems(): Observable<any>;

  add(commission: Commission): Observable<any>;

  edit(commission: Commission): Observable<any>;

  delete(item: any): Observable<any>;
}
